/**
 * Opens Klaviyo newsletter popups from `#newsletter-<handle>` anchor links.
 *
 * The handle names a `newsletter_form` metaobject entry, and the snippet
 * that loads this module (snippets/newsletter-popup.liquid) renders one
 * `[data-newsletter-form]` element per entry carrying its Klaviyo form ID.
 * The anchor is only a carrier for the handle — the click is always
 * cancelled, so the page never scrolls or navigates and the URL never
 * gains the hash.
 *
 * Links can be authored anywhere a link can go — rich text, menus,
 * buttons — so the listener is delegated on the document and content
 * re-rendered after load keeps working.
 *
 * `_klOnsite` is Klaviyo's onsite queue, provided by the Klaviyo app embed;
 * pushing onto a plain array before the embed boots is part of its contract.
 */

const PREFIX = '#newsletter-';

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const link = event.target instanceof Element && event.target.closest(`a[href*="${PREFIX}"]`);
  if (!link) return;

  const hash = new URL(link.href, location.href).hash;
  if (!hash.startsWith(PREFIX)) return;

  event.preventDefault();

  const handle = decodeURIComponent(hash.slice(PREFIX.length));
  const formId = document.querySelector(`[data-newsletter-form="${CSS.escape(handle)}"]`)?.dataset
    .klaviyoFormId;
  if (!formId) return;

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
});
